import { Text } from '@react-three/drei';
import * as THREE from 'three';


// Function to convert lat/long to Cartesian coordinates
function latLongToCartesian(lat, lon) {
    const phi = (90 - lat) * (Math.PI / 180); // Convert latitude to radians
    const theta = (lon + 180) * (Math.PI / 180); // Convert longitude to radians
  
    const x = -RADIUS * Math.sin(phi) * Math.cos(theta);
    const y = RADIUS * Math.cos(phi);
    const z = RADIUS * Math.sin(phi) * Math.sin(theta);
  
    const position = new THREE.Vector3(x, y, z).normalize().multiplyScalar(RADIUS + OFFSET);
    return position;
    // return new THREE.Vector3(x, y, z);
  }

  
  const RADIUS = 5;
  const OFFSET = 0.01;
  export default function Marker({ lat, lon, localizedTitle, size, color = 'red', lan='en', handleLabelClick }) {
    // Calculate position on the sphere
    const position = latLongToCartesian(lat, lon);
    const title = localizedTitle[lan]
    // const positionText = latLongToCartesian(lat - 2.3, lon);
  
    // Calculate rotation to align with sphere's surface
    const lookAtPosition = new THREE.Vector3(0, 0, 0); // Sphere center
    const boxUp = new THREE.Vector3(0, 1, 0); // Box default up direction
    const rotationMatrix = new THREE.Matrix4().lookAt(position, lookAtPosition, boxUp);
    const rotation = new THREE.Euler().setFromRotationMatrix(rotationMatrix);
  
  
  
    return (
        <group key={title} position={position} rotation={rotation} 
        // onClick={()=> handleLabelClick({title})}
        >
          <mesh>
            <circleGeometry args={[0.04, 32]} />
            <meshBasicMaterial color={color} opacity={0.8} transparent />
          </mesh>
          <Text
            scale={[size, size, size]}
            position={[0, -0.2, 0]}
            depth={0}
            height={0}
            curveSegments={2}
            color={color}
            material={
              new THREE.MeshBasicMaterial({
                transparent: true,
                opacity: 0.9
              })
            }
          >
            {title.replace(" ", "\n")}
          </Text>
        </group>
    );
  }